<template>
  <el-dialog
    title="通讯录"
    :visible.sync="ishow"
    width="600px"
    @closed="onclosed"
    class="user-address-dialog"
  >
    <div class="address-main">
        <el-card class="address-item" v-for="d in datas" :key="d.id">
            <el-row>
                <el-col :span="6">姓名: {{d.name}}</el-col>
                <el-col :span="6">账号: {{d.acct}} </el-col>
                <el-col :span="12">电话: {{d.phone}}</el-col>
            </el-row>
        </el-card>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      ishow: false,
      datas: null,
    };
  },
  methods: {
    onclosed() {
      this.$emit("update:show", false);
    },
    list() {
        let _this = this;
        _this.$http.post(["user/listAdress"], [function(data) {_this.datas = data; _this.ishow = true;}]);
    },
  },
  watch: {
    show(val) {
      if (val) {
          this.list();
      } else {
        this.ishow = val;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.user-address-dialog {
  .address-main {
    height: 400px;
    overflow: auto;

    .address-item {
        margin-top: 10px;
    }
  }
}
</style>